module.exports = {
    serverDomain: process.env.REACT_APP_API_URL
}